import React, { useState } from "react";
import CrewUpdate from "./CrewUpdate";
import CrewInsertion from "./CrewInsertion";

const CrewMaster = () => {
  const [active, setActive] = useState("insert");

  return (
    <div style={{ minHeight: "90vh" }} className="papaDiv">
      <div className="row m-5">
        <div className="d-flex justify-content-center m-2">
          <button
            onClick={() => {
              setActive("insert");
            }}
            className={`btn btn-sm btn-outline-dark me-1 ${
              active === "insert" && "active"
            }`}
          >
            Insert
          </button>
          <button
            onClick={() => {
              setActive("update");
            }}
            className={`btn btn btn-outline-dark ms-1 ${
              active === "update" && "active"
            }`}
          >
            Update
          </button>
          <hr />
        </div>
      </div>
      <div className="row">
        {active === "insert" ? (
          <div className="">
            <CrewInsertion />{" "}
          </div>
        ) : (
          <div className="">
            <CrewUpdate />
          </div>
        )}
      </div>
    </div>
  );
};
export default CrewMaster;
